import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

enum AppColors {
  '#24A6E8',
  '#0D9E5D',
  '#CE9F47',
  '#855CF8',
  '#F5A800',
  '#1E40AF',
  '#B91C1C',
}

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  generateHash() {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  }

  getState(startDate, endDate?) {
    startDate = this.toUnix(startDate);
    if (endDate) endDate = this.toUnix(endDate);
    //En attente
    if (startDate > Date.now()) return 'pending';
    //En cours
    else if (startDate < Date.now() && (endDate > Date.now() || !endDate))
      return 'running';
    //Terminé
    else if (endDate < Date.now()) return 'over';
  }

  sortByProperty(list: any, property: string) {
    const sortedList = list.sort((a: any, b: any) => {
      if (a['type'] > b['type']) {
        return 1;
      }
      if (a['type'] < b['type']) {
        return -1;
      }
      return 0;
    });

    return sortedList;
  }

  emptyIsNull(val) {
    return val == null || val == undefined || val.length === 0 ? null : val;
  }

  toIsoDate(date) {
    return this.emptyIsNull(new Date(date).toISOString().split('.')[0] + 'Z');
  }

  toUnix(date) {
    return this.emptyIsNull(new Date(date).getTime());
  }

  getAppColor(index) {
    return AppColors[index];
  }

  getAppColors() {
    return Object.keys(AppColors)
      .filter(this.StringIsNumber)
      .map(key => AppColors[key]);
  }

  toUpperCase(label: string, exclude: string[] = []): string {
    const words = label.split(' ');
    const result = words.map(word => {
      if (exclude.includes(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return result.join(' ');
  }

  cleanNullToUndefined(obj: any): any {
    if (obj === null) {
      return undefined;
    }

    if (typeof obj !== 'object') {
      return obj;
    }

    if (obj instanceof Array) {
      return obj.map(this.cleanNullToUndefined);
    }

    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [key]: this.cleanNullToUndefined(obj[key]),
      }),
      {},
    );
  }
  cleanEmptyToNull(obj: any): any {
    if (obj === null) {
      return null;
    }
    if (obj === '' && obj.trim().length === 0) {
      return null;
    }

    if (typeof obj !== 'object') {
      return obj;
    }
    if (obj instanceof Array) {
      return obj.map(this.cleanEmptyToNull);
    }

    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [key]: this.cleanEmptyToNull(obj[key]),
      }),
      {},
    );
  }
  getQuickRandomId() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  }

  private StringIsNumber = value => isNaN(Number(value)) === false;

  getUrlParams(url: string) {
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    let obj = {};

    if (queryString) {
      queryString = queryString.split('#')[0];

      let arr = queryString.split('&');

      for (let i = 0; i < arr.length; i++) {
        let a = arr[i].split('=');

        let paramName = a[0];
        let paramValue = typeof a[1] === 'undefined' ? true : a[1];

        if (typeof paramValue === 'string')
          if (paramName.match(/\[(\d+)?\]$/)) {
            let key = paramName.replace(/\[(\d+)?\]/, '');
            if (!obj[key]) obj[key] = [];

            if (paramName.match(/\[\d+\]$/)) {
              let index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              obj[key].push(paramValue);
            }
          } else {
            if (!obj[paramName]) {
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === 'string') {
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              obj[paramName].push(paramValue);
            }
          }
      }
    }

    return obj;
  }
  createValueValidator(
    minValue: number,
    maxValue: number,
    errorCode: 'min' | 'max' | 'range',
    errorParams: { [key: string]: number },
  ) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value < minValue || value > maxValue) {
        return {
          [errorCode]: {
            ...errorParams,
            actual: value,
          },
        };
      }

      return null;
    };
  }

  minValuePercentValidator(minPercentage: number) {
    const minValue = minPercentage / 100;

    return this.createValueValidator(minValue, Infinity, 'min', {
      min: minPercentage,
    });
  }
  maxValuePercentValidator(maxPercentage: number) {
    const maxValue = maxPercentage / 100;

    return this.createValueValidator(-Infinity, maxValue, 'max', {
      max: maxPercentage,
    });
  }
  valueRangePercentValidator(minPercentage: number, maxPercentage: number) {
    const minValue = minPercentage / 100;
    const maxValue = maxPercentage / 100;

    return this.createValueValidator(minValue, maxValue, 'range', {
      min: minPercentage,
      max: maxPercentage,
    });
  }
}
